import { useState, useEffect, useRef, useCallback } from "react";
import "../../CSS/GlobalSearch.css";
import api from "../../api.js";
import { createPortal } from "react-dom";

// Build absolute image URL using the same base URL as the API axios instance
// e.g. fullUrl = "/Otherimg/100001/Package/file.png"
//   → "http://localhost:5257/Otherimg/100001/Package/file.png"
const apiBase = (api.defaults.baseURL || "").replace(/\/api\/?$/, "").replace(/\/$/, "");
// const imgUrl  = (relativePath) => relativePath ? `${apiBase}/${relativePath.replace(/^\//, "")}` : "";
// console.log("apiBase →", apiBase);
const imgUrl = (relativePath) => {
  const url = relativePath ? `${apiBase}/${relativePath.replace(/^\//, "")}` : "";
  console.log("imgUrl →", url);   // ← add this temporarily
  return url;
};

// ── HELPERS ────────────────────────────────────────────────────
const fmt = (n) => n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

function useToast() {
  const [toasts, setToasts] = useState([]);
  const toast = useCallback((msg, type = "info") => {
    const icons = { ok: "✓", err: "✕", warn: "⚠", info: "ℹ" };
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, msg, type, icon: icons[type] || "ℹ" }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), 3200);
  }, []);
  return { toasts, toast };
}

// ── SVG ICONS ──────────────────────────────────────────────────
const IconSearch = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
  </svg>
);
const IconConsignment = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const IconPrint = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6 9 6 2 18 2 18 9" />
    <path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2" />
    <rect x="6" y="14" width="12" height="8" />
  </svg>
);
const IconShare = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);
const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const IconPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);
const IconShield = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const IconImage = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" />
  </svg>
);
const IconDollar = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
  </svg>
);
const IconDownload = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
const IconExternalLink = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
    <polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);
const IconFile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);
const IconMobile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="5" y="2" width="14" height="20" rx="2" /><line x1="12" y1="18" x2="12.01" y2="18" />
  </svg>
);
const IconMonitor = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
  </svg>
);
const IconGlobe = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
  </svg>
);
const IconTarget = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="3" />
  </svg>
);

const IconTruck = () => (
  // <svg viewBox="0 0 24 24" fill="#fff">
  //   <path d="M1 7a1 1 0 011-1h11a1 1 0 011 1v7H1z" />
  //   <path d="M14 10h4.5a1 1 0 01.8.4l2.2 2.9a1 1 0 01.2.6V17a1 1 0 01-1 1H14z" />
  //   <circle cx="6" cy="18.5" r="2" fill="#fff" />
  //   <circle cx="17.5" cy="18.5" r="2" fill="#fff" />
  // </svg>
  <span style={{ fontSize: 16, lineHeight: 1 }}>🚚</span>
);
const IconHub = () => (
  <svg viewBox="0 0 24 24" fill="#fff">
    <path d="M12 2.5L2.5 10h2V20a1 1 0 001 1h5v-6.5h3V21h5a1 1 0 001-1V10h2z" />
  </svg>
);
// const IconScooter = () => (
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="5" cy="19" r="2.6" fill="currentColor" stroke="none" />
//     <circle cx="18" cy="19" r="2.6" fill="currentColor" stroke="none" />
//     <path d="M5 19h4l2.2-6h4.3l1.3 3h1.7a2.3 2.3 0 012.3 2.3V19" />
//     <path d="M11.5 13V7.5h3.5" />
//   </svg>
// );
const IconScooter = () => (
  <span style={{ fontSize: 16, lineHeight: 1 }}>🛵</span>
);
const IconDelivered = () => (
  <span style={{ fontSize: 16, lineHeight: 1 }}>✅</span>
);


// ── TOAST DISPLAY ───────────────────────────────────────────────
function ToastWrap({ toasts }) {
  return (
    <div className="gs-toast-wrap">
      {toasts.map((t) => (
        <div key={t.id} className={`gs-toast ${t.type}`}>
          <span style={{ fontSize: 14 }}>{t.icon}</span>
          {t.msg}
        </div>
      ))}
    </div>
  );
}

// ── LIGHTBOX ────────────────────────────────────────────────────
function Lightbox({ item, onClose, onToast }) {
  useEffect(() => {
    if (!item) return;
    // Find the .main scroll container
    const main = document.querySelector(".main");
    if (!main) return;
    // Current scroll position inside .main + center it in the visible area
    // mainRect.height = visible height of .main on screen
    const mainRect    = main.getBoundingClientRect();
    const scrollTop   = main.scrollTop;
    const visibleH    = mainRect.height;
    // Approximate modal height
    const modalH      = 480;
    const offset      = scrollTop + (visibleH / 2) - (modalH / 2) - 80;
    document.documentElement.style.setProperty(
      "--gs-lb-offset", Math.max(offset, scrollTop + 20) + "px"
    );
  }, [item]);

  if (!item) return null;
  return (
    <div className="gs-lightbox show" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="gs-lb-content">
        <div className="gs-lb-hd">
          <div>
            <h3>{item.name}</h3>
            <p>{item.type} · Consignment Image</p>
          </div>
          <button className="gs-lb-x" onClick={onClose}>✕</button>
        </div>
        <div className="gs-lb-img" style={
        item.relativePath && !item.relativePath.endsWith('.pdf')
          ? { backgroundImage: `url(${imgUrl(item.relativePath)})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', fontSize: 0 }
          : {}
      }>
        {(!item.relativePath || item.relativePath.endsWith('.pdf')) && <span style={{ fontSize: 80 }}>{item.icon}</span>}
      </div>
        <div className="gs-lb-ft">
          <button className="gs-btn gs-btn-ghost gs-btn-sm" onClick={onClose}>Close</button>
          <button className="gs-btn gs-btn-navy gs-btn-sm" onClick={() => { if (item.fullUrl) { const a = document.createElement("a"); a.href = imgUrl(item.relativePath); a.download = item.name; a.click(); } else { onToast("No file URL", "warn"); } }}>
            <IconDownload /> Download
          </button>
        </div>
      </div>
    </div>
  );
}

// ── GEO MAP ─────────────────────────────────────────────────────
function GeoMap({ lat, lng, address, entryMode, label, onToast }) {
  const hasGeo = lat && lng;
  const emCls  = entryMode === "Mobile" ? "mobile" : entryMode === "Application" ? "app" : "web";
  const EmIcon = entryMode === "Mobile" ? IconMobile : entryMode === "Application" ? IconMonitor : IconGlobe;

  return (
    <div className="gs-geo-card">
      <div className="gs-geo-map">
          <div className="gs-geo-grid-bg" />
          <svg className="gs-geo-roads" viewBox="0 0 320 140" preserveAspectRatio="none">
            <path d="M-10 90 Q 80 60 160 75 T 330 50" stroke="rgba(37,99,235,.25)" strokeWidth="6" fill="none" />
            <path d="M40 -10 Q 90 50 150 70 T 240 150" stroke="rgba(13,148,136,.2)" strokeWidth="4" fill="none" />
            <path d="M-10 30 L 330 110" stroke="rgba(148,163,184,.25)" strokeWidth="2" fill="none" strokeDasharray="6 5" />
          </svg>
          <div className="gs-geo-pin-pulse" />
          <div className="gs-geo-pin">
            <svg viewBox="0 0 24 24" fill="#2563eb" stroke="#fff" strokeWidth="1.5">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
              <circle cx="12" cy="10" r="3" fill="#fff" stroke="none" />
            </svg>
          </div>
          {/* Location name label — always shown even without GPS */}
          <div className="gs-geo-coords">
            <IconPin />
            {address || "—"}
          </div>
          {hasGeo && (
            <div className="gs-geo-coords" style={{ left: "auto", right: 8 }}>
              <IconTarget />
              {lat.toFixed(4)}, {lng.toFixed(4)}
            </div>
          )}
          <div className="gs-geo-zoom">
            <button onClick={() => onToast("Zoom in", "info")}>+</button>
            <button onClick={() => onToast("Zoom out", "info")}>&minus;</button>
          </div>
        </div>
      <div className="gs-geo-detail">
        <div className="gs-geo-addr">📦 {address || "Location not available"}</div>
        <div className="gs-geo-meta-row">
          <span className={`gs-geo-entry-tag ${emCls}`}>
            <EmIcon /> Booked via {entryMode}
          </span>
          {hasGeo && (
            <span className="gs-geo-link" onClick={() => onToast(`Opening ${lat.toFixed(4)}, ${lng.toFixed(4)} in Maps…`, "info")}>
              <IconExternalLink /> Open in Maps
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

// ── JOURNEY BAR ─────────────────────────────────────────────────
function JourneyBar({ journey, bookDate, lastDate }) {
  const doneCount = journey.filter((s) => s.done).length;
  const pct = Math.round((doneCount / journey.length) * 100);

  return (
    <div className="gs-journey-card">
      <div className="gs-journey-header">
        <div className="gs-journey-title">Shipment Journey</div>
        <div className="gs-journey-dates">{bookDate} → {lastDate}</div>
      </div>

      <div className="gs-journey-stops">
        {journey.map((s, i) => {
          const dotCls = s.delivered ? "done" : s.current ? "current" : s.done ? "done" : "";
          return (
            <div key={i} style={{ display: "contents" }}>
              {i > 0 && (
                <div className={`gs-jline${s.done ? " done" : i === journey.findIndex((x) => !x.done) - 1 ? " partial" : ""}`} />
              )}
              <div className="gs-jstop">
                <div className={`gs-jstop-dot ${dotCls}`}>
                  {s.delivered
                    ? <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    : s.done
                    ? <svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><polyline points="20 6 9 17 4 12" /></svg>
                    : <svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><circle cx="12" cy="12" r="5" /></svg>
                  }
                </div>
                <div className="gs-jstop-name">{s.name}</div>
                <div className="gs-jstop-date">{s.date}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="gs-progress-wrap">
        <div className="gs-progress-info">
          <span className="gs-prog-lbl">{pct === 100 ? "Delivery Complete ✓" : "In Transit"}</span>
          <span className="gs-prog-pct">{pct}%</span>
        </div>
        <div className="gs-prog-bar">
          <div className="gs-prog-fill" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
}

// ── GALLERY ─────────────────────────────────────────────────────
function Gallery({ images, onOpen }) {
  const [filter, setFilter] = useState("All");
  const types = ["All", ...new Set(images.map((i) => i.type))];
  const filtered = filter === "All" ? images : images.filter((i) => i.type === filter);

  return (
    <>
      <div className="gs-img-type-filter">
        {types.map((t) => (
          <button
            key={t}
            className={`gs-itf-chip${filter === t ? " active" : ""}`}
            onClick={() => setFilter(t)}
          >
            {t}{t === "All" ? ` (${images.length})` : ` (${images.filter((i) => i.type === t).length})`}
          </button>
        ))}
      </div>
      <div className="gs-img-gallery">
        {filtered.length === 0
          ? <div className="gs-gal-empty">No images in this category</div>
          : filtered.map((img, i) => (
            <div key={i} className="gs-gal-item" onClick={() => onOpen(img)}>
              <div
                className="gs-gal-thumb"
                style={img.relativePath && !img.relativePath.endsWith('.pdf')
                  ? { backgroundImage: `url(${imgUrl(img.relativePath)})`, backgroundSize: "cover", backgroundPosition: "center" }
                  : {}}
              >
                {(!img.relativePath || img.relativePath.endsWith('.pdf')) && img.icon}
              </div>
              <span className={`gs-gal-type-tag gs-gtt-${img.type.toLowerCase()}`}>{img.type}</span>
              <div className="gs-gal-dl">
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{img.name}</span>
                <IconDownload />
              </div>
            </div>
          ))
        }
      </div>
    </>
  );
}

// ── MAIN COMPONENT ──────────────────────────────────────────────
export default function GlobalSearch() {
  const [query,        setQuery]        = useState("");
  const [data,         setData]         = useState(null);
  const [loading,      setLoading]      = useState(false);
  const [notFound,     setNotFound]     = useState(false);
  const [lightboxItem, setLightboxItem] = useState(null);
  const inputRef = useRef(null);
  const { toasts, toast } = useToast();

  // Keyboard shortcuts
  useEffect(() => {
    function handler(e) {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") { e.preventDefault(); inputRef.current?.select(); }
      if (e.key === "Escape") { inputRef.current?.blur(); setLightboxItem(null); }
    }
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  // ── SEARCH ────────────────────────────────────────────────────
  const doSearch = async (q = query) => {
    const raw = q.trim().toUpperCase();
    if (!raw) { toast("Enter a consignment number", "warn"); return; }

    setLoading(true);
    setNotFound(false);
    setData(null);

    try {
      const res = await api.get(`/api/global-search?query=${encodeURIComponent(raw)}`);
      if (!res.data || !res.data.cnr) {
        setNotFound(true);
        toast(`Consignment ${raw} not found`, "err");
      } else {
        setData(res.data);
        toast(`Consignment ${res.data.cnr} loaded`, "ok");
      }
    } catch (err) {
      setNotFound(true);
      toast(`Consignment ${raw} not found`, "err");
    } finally {
      setLoading(false);
    }
  };

  const quickSearch = (v) => { setQuery(v); doSearch(v); };

  // ── DERIVED VALUES ────────────────────────────────────────────
  const isDelivered  = data?.status === "DELIVERED";
  const entryColor   = data?.modeOfEntry === "Mobile" ? "green" : data?.modeOfEntry === "Application" ? "blue" : "amber";
  const entryIcon    = data?.modeOfEntry === "Mobile" ? "📱" : data?.modeOfEntry === "Application" ? "💻" : "🌐";
  const lastTracking = data?.tracking?.[data.tracking.length - 1];
  const colorMap     = { blue: "var(--gs-blue-lt)", amber: "var(--gs-amber-lt)", purple: "var(--gs-purple-lt)", teal: "var(--gs-teal-lt)", green: "var(--gs-green-lt)" };

  const infoFields = data ? [
    { lbl: "Book Place",    val: data.bookPlace,    cls: "blue" },
    { lbl: "Delivery Place",val: data.deliveryPlace,cls: "teal" },
    { lbl: "Book Date",     val: data.bookDate },
    { lbl: "Book Time",     val: data.bookTime },
    { lbl: "Services",      val: data.services },
    { lbl: "Weight",        val: data.weight + " kg" },
    { lbl: "Packages",      val: data.pkgs + " pkg" },
    { lbl: "Job / Account", val: data.jobname },
    { lbl: "Mode of Entry", val: `${entryIcon} ${data.modeOfEntry}`, cls: entryColor },
    { lbl: "Username",      val: data.username },
  ] : [];

  return (
    <div className="gs-root">
      <div className="gs-page">

        {/* ── SEARCH HERO ── */}
        <div className="gs-search-hero">
           {/* <div className="gs-sh-label">Shipment Intelligence</div> */}
          <h1 className="gs-sh-title">Global <span>Search</span></h1>
          {/* <p className="gs-sh-sub">Track any consignment · View booking details · Download POD</p>  */}

          <div className={`gs-search-box-wrap${loading ? " gs-searching" : ""}`}>
            <span className="gs-sb-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 5v4M3 5h4M3 19v-4M3 19h4M21 5v4M21 5h-4M21 19v-4M21 19h-4M8 5v14M12 5v14M16 5v14" />
              </svg>
            </span>
            <input
              ref={inputRef}
              className="gs-sb-input"
              type="text"
              placeholder="Enter Consignment No. or Order No…"
              autoComplete="off"
              spellCheck={false}
              value={query}
              onChange={(e) => setQuery(e.target.value.toUpperCase())}
              onKeyDown={(e) => e.key === "Enter" && doSearch()}
            />
            <button className="gs-sb-btn" onClick={() => doSearch()} disabled={loading}>
              <IconSearch /> {loading ? "Searching…" : "Search"}
            </button>
          </div>

          {/* <div className="gs-search-hints">
            <span className="gs-hint-lbl">Try:</span>
            <span className="gs-hint-chip" onClick={() => quickSearch("1632864")}>1632864</span>
            <span className="gs-hint-chip" onClick={() => quickSearch("DSTL0702306")}>DSTL0702306</span>
            <span className="gs-hint-chip" onClick={() => quickSearch("MBWD0004735")}>MBWD0004735</span>
          </div> */}
        </div>

        {/* ── EMPTY / NOT FOUND STATE ── */}
        {!data && !loading && (
          <div className="gs-empty-screen">
            {notFound ? (
              <>
                <div className="gs-empty-icon-wrap" style={{ background: "linear-gradient(135deg,var(--gs-red-lt),var(--gs-amber-lt))" }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="var(--gs-red)" strokeWidth="1.5">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
                  </svg>
                </div>
                <div className="gs-empty-title" style={{ color: "var(--gs-red)" }}>Not Found</div>
                <div className="gs-empty-sub">
                  No consignment found for <strong>{query}</strong><br />
                  Please verify the number and try again.
                </div>
              </>
            ) : (
              <>
                <div className="gs-empty-icon-wrap">
                  <svg viewBox="0 0 24 24" strokeWidth="1.5" fill="none" stroke="var(--gs-blue)">
                    <path d="M21 21l-4.35-4.35M17 11A6 6 0 115 11a6 6 0 0112 0z" />
                  </svg>
                </div>
                <div className="gs-empty-title">Search for a Consignment</div>
                <div className="gs-empty-sub">
                  Enter a consignment number or manifest reference above<br />
                  to instantly view booking details and live tracking status.
                </div>
              </>
            )}
          </div>
        )}

        {/* ── RESULTS ── */}
        {data && (
          <div className="gs-results-area show">

            {/* CNR BANNER */}
            <div className="gs-cnr-banner">
              <div className="gs-cnr-l">
                <div className="gs-cnr-icon"><IconConsignment /></div>
                <div>
                  <div className="gs-cnr-label">Consignment Number</div>
                  <div className="gs-cnr-number">{data.cnr}</div>
                  <div className="gs-cnr-ref">
                    {data.ref ? `Ref: ${data.ref}` : `Booked: ${data.bookDate} at ${data.bookTime} · ${data.services}`}
                  </div>
                </div>
              </div>
              <div className="gs-cnr-r">
                <div className="gs-cnr-stat">
                  <div className="gs-cs-val">{data.pkgs}</div>
                  <div className="gs-cs-lbl">Packages</div>
                </div>
                <div className="gs-cnr-stat">
                  <div className="gs-cs-val">{data.weight}</div>
                  <div className="gs-cs-lbl">Weight (kg)</div>
                </div>
                <div className="gs-cnr-stat">
                  <div className="gs-cs-val">
                    {data.tracking?.length
                      ? Math.ceil((new Date(data.tracking[data.tracking.length - 1].rawDate || Date.now()) - new Date(data.tracking[0].rawDate || Date.now())) / (1000 * 60 * 60 * 24)) + 1
                      : "—"
                    }
                  </div>
                  <div className="gs-cs-lbl">Days</div>
                </div>
                <div
                  className="gs-cnr-status-badge"
                  style={!isDelivered ? { background: "rgba(37,99,235,.25)", borderColor: "rgba(147,197,253,.3)" } : {}}
                >
                  <span
                    className="gs-csb-dot"
                    style={!isDelivered ? { background: "#60a5fa" } : {}}
                  />
                  <span
                    className="gs-csb-text"
                    style={!isDelivered ? { color: "#93c5fd" } : {}}
                  >
                    {data.status}
                  </span>
                </div>
                <div className="gs-cnr-actions">
                  {/* <button className="gs-btn-cnr" onClick={() => toast("Printing…", "info")}>
                    <IconPrint /> Print
                  </button> */}
                  <button className="gs-btn-cnr" onClick={() => toast("Sharing…", "info")}>
                    <IconShare /> Share
                  </button>
                </div>
              </div>
            </div>

            {/* JOURNEY BAR */}
            <JourneyBar
              journey={data.journey}
              bookDate={data.bookDate}
              lastDate={lastTracking?.date || "—"}
            />

            {/* MAIN LAYOUT */}
            <div className="gs-main-layout">

              {/* LEFT COLUMN */}
              <div>
                {/* Booking Details */}
                <div className="gs-card">
                  <div className="gs-band">
                    <div className="gs-band-icon"><IconConsignment /></div>
                    <div>
                      <div className="gs-band-title">Booking Details</div>
                      <div className="gs-band-sub">Full consignment information</div>
                    </div>
                  </div>
                  <div className="gs-card-body">
                    <div className="gs-info-grid">
                      {infoFields.map((f, i) => (
                        <div key={i} className="gs-info-cell">
                          <div className="gs-ic-lbl">{f.lbl}</div>
                          <div className={`gs-ic-val ${f.cls || ""}`}>{f.val || "—"}</div>
                        </div>
                      ))}
                    </div>
                    <div className="gs-party-row">
                      <div className="gs-party-box">
                        <div className="gs-pb-type sender">
                          <span className="gs-pb-type-dot" />Consignor / Sender
                        </div>
                        <div className="gs-pb-name">{data.consignor}</div>
                        <div className="gs-pb-detail">📦 {data.bookPlace} &nbsp;|&nbsp; {data.bookDate}</div>
                      </div>
                      <div className="gs-party-box">
                        <div className="gs-pb-type receiver">
                          <span className="gs-pb-type-dot" />Consignee / Receiver
                        </div>
                        <div className="gs-pb-name">{data.consignee}</div>
                        <div className="gs-pb-detail">📍 {data.deliveryPlace} &nbsp;|&nbsp; {lastTracking?.date}</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tracking History Table */}
                <div className="gs-card">
                  <div className="gs-band teal">
                    <div className="gs-band-icon"><IconShield /></div>
                    <div>
                      <div className="gs-band-title">Tracking History</div>
                      <div className="gs-band-sub">All movement records</div>
                    </div>
                    <div className="gs-band-r">
                      <span className="gs-band-badge">{data.tracking?.length} records</span>
                    </div>
                  </div>
                  <div className="gs-table-wrap">
                    <table className="gs-trk-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Reference No.</th>
                          <th>Date &amp; Time</th>
                          <th>Status</th>
                          <th>Received By</th>
                          <th>Remark</th>
                          <th className="center">Branch</th>
                          <th className="center">User</th>
                          <th className="center">Mode</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.tracking?.map((t, i) => {
                          const isLast = i === data.tracking.length - 1;
                          const sType  =
                            t.status === "DELIVERED"                      ? "gs-sc-del"   :
                            t.status.toLowerCase().includes("forward")    ? "gs-sc-fwd"   :
                            t.status.toLowerCase().includes("receiv")     ? "gs-sc-recv"  : "gs-sc-other";
                          return (
                            <tr key={i} className={isLast ? "last-row" : ""}>
                              <td style={{ color: "var(--gs-muted)", fontSize: 12 }}>{i + 1}</td>
                              <td><span className="gs-ref-code">{t.refNo}</span></td>
                              <td>
                                <div className="gs-date-cell">{t.date}</div>
                                <div className="gs-date-time">{t.time}</div>
                              </td>
                              <td>
                                <span className={`gs-status-chip ${sType}`}>
                                  {isLast ? "✓ " : t.status.includes("Forward") ? "→ " : ""}{t.status}
                                </span>
                              </td>
                              <td style={{ fontSize: 12, color: "var(--gs-slate)" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                  <span>{t.receivedBy || "—"}</span>
                                  {t.signaturePath && (
                                    <img
                                      src={imgUrl(t.signaturePath)}
                                      alt="Signature"
                                      title="Click to view signature"
                                      style={{ height: 20, cursor: "pointer", border: "1px solid var(--gs-border, #ddd)", borderRadius: 4, background: "#fff" }}
                                      onClick={() => setLightboxItem({ name: `${t.receivedBy || "Receiver"}'s Signature`, type: "Signature", icon: "✍️", relativePath: t.signaturePath, fullUrl: t.signaturePath })}
                                    />
                                  )}
                                </div>
                              </td>
                              <td
                                style={{ fontSize: 12, color: "var(--gs-amber)", fontWeight: 600, maxWidth: 160 }}
                                title={t.remark || ""}
                              >
                                <span style={{ display: "inline-block", maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "bottom" }}>
                                  {t.remark || "—"}
                                </span>
                              </td>
                              <td className="center"><span className="gs-branch-tag">{t.branch}</span></td>
                              <td className="center" style={{ fontSize: 12, color: "var(--gs-muted)" }}>{t.user}</td>
                              <td className="center"><span className="gs-mode-tag">{t.mode}</span></td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Images Gallery */}
                <div className="gs-card">
                  <div className="gs-band amber">
                    <div className="gs-band-icon"><IconImage /></div>
                    <div>
                      <div className="gs-band-title">Consignment Images</div>
                      <div className="gs-band-sub">Photos, labels, invoices &amp; POD scans</div>
                    </div>
                    <div className="gs-band-r">
                      <button className="gs-dl-all-btn" onClick={() => toast("Downloading all images as ZIP…", "ok")}>
                        <IconDownload /> Download All
                      </button>
                    </div>
                  </div>
                  <Gallery images={data.images || []} onOpen={setLightboxItem} />
                </div>

                {/* Other Expenses */}
                <div className="gs-card">
                  <div className="gs-band green">
                    <div className="gs-band-icon"><IconDollar /></div>
                    <div>
                      <div className="gs-band-title">Other Expenses</div>
                      <div className="gs-band-sub">Additional charges incurred on this consignment</div>
                    </div>
                    <div className="gs-band-r">
                      <span className="gs-band-badge">
                        ₹ {data.expenses?.length ? fmt(data.expenses.reduce((a, e) => a + e.amount, 0)) : "0"}
                      </span>
                    </div>
                  </div>
                  <div className="gs-table-wrap">
                    <table className="gs-exp-table">
                      <thead>
                        <tr>
                          <th>Expense Category</th>
                          <th>Date</th>
                          <th>Entered By</th>
                          <th className="center">Mode</th>
                          <th className="right">Amount (₹)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!data.expenses?.length ? (
                          <tr><td colSpan="5" style={{ textAlign: "center", padding: 18, color: "var(--gs-muted)", fontStyle: "italic" }}>No additional expenses recorded</td></tr>
                        ) : data.expenses.map((e, i) => {
                          const emStyle =
                            e.mode === "Mobile"      ? "background:var(--gs-green-lt);color:var(--gs-green);border-color:rgba(22,163,74,.2);" :
                            e.mode === "Application" ? "background:var(--gs-blue-lt);color:var(--gs-blue);border-color:rgba(37,99,235,.2);"  :
                            "background:var(--gs-s3);color:var(--gs-slate);";
                          return (
                            <tr key={i}>
                              <td>
                                <span className="gs-exp-cat">
                                  <span className="gs-exp-icon" style={{ background: colorMap[e.color] || "var(--gs-s3)" }}>{e.icon}</span>
                                  {e.cat}
                                </span>
                              </td>
                              <td style={{ fontSize: 12, color: "var(--gs-slate)" }}>{e.date}</td>
                              <td style={{ fontSize: 12, color: "var(--gs-muted)" }}>{e.by}</td>
                              <td className="center"><span className="gs-exp-mode" style={{ cssText: emStyle }}>{e.mode}</span></td>
                              <td className="right" style={{ fontWeight: 700, color: "var(--gs-navy)" }}>₹ {fmt(e.amount)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      {!!data.expenses?.length && (
                        <tfoot>
                          <tr>
                            <td colSpan="4">TOTAL OTHER EXPENSES</td>
                            <td className="right">₹ {fmt(data.expenses.reduce((a, e) => a + e.amount, 0))}</td>
                          </tr>
                        </tfoot>
                      )}
                    </table>
                  </div>
                </div>
              </div>

              {/* RIGHT COLUMN */}
              <div>
                {/* Live Timeline */}
                <div className="gs-card">
                  <div className="gs-band green">
                    <div className="gs-band-icon"><IconClock /></div>
                    <div>
                      <div className="gs-band-title">Live Timeline</div>
                      <div className="gs-band-sub">Step-by-step movement</div>
                    </div>
                  </div>
                  <div className="gs-timeline">
                    {/* {data.tracking?.map((t, i) => {
                      const isDeliverRow = t.status === "DELIVERED";
                      const isLast = i === data.tracking.length - 1;
                      return (
                        <div key={i} className="gs-tl-item done">
                          <div className="gs-tl-line-wrap">
                            <div className={`gs-tl-dot ${isDeliverRow ? "done" : "done"}`}>
                              {isDeliverRow
                                ? <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                : <svg viewBox="0 0 24 24" fill="none" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                              }
                            </div>
                          </div>
                          <div className="gs-tl-body">
                            <div className={`gs-tl-status ${isDeliverRow ? "delivered" : ""}`}>{t.status}</div>
                            <div className="gs-tl-time">{t.date} &nbsp;{t.time}</div>
                            <div className="gs-tl-ref">{t.refNo}</div>
                            <div className="gs-tl-badges">
                              <span className="gs-tl-badge branch">{t.branch}</span>
                              {t.remark    && (
                                <span
                                  className="gs-tl-badge remark"
                                  title={t.remark}
                                  style={{ maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block", verticalAlign: "bottom" }}
                                >
                                  {t.remark}
                                </span>
                              )}
                              {t.receivedBy && <span className="gs-tl-badge user">{t.receivedBy}</span>}
                              {t.signaturePath && (
                                <img
                                  src={imgUrl(t.signaturePath)}
                                  alt="Signature"
                                  title="Click to view signature"
                                  style={{ height: 22, cursor: "pointer", border: "1px solid var(--gs-border, #ddd)", borderRadius: 4, background: "#fff", verticalAlign: "middle" }}
                                  onClick={() => setLightboxItem({ name: `${t.receivedBy || "Receiver"}'s Signature`, type: "Signature", icon: "✍️", relativePath: t.signaturePath, fullUrl: t.signaturePath })}
                                />
                              )}
                              <span className="gs-tl-badge mode">{t.mode}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })} */}

                    {data.tracking?.map((t, i) => {
                      const stageMeta = {
                        O: { cls: "forwarded", color: "#2f6bff", icon: <IconTruck /> },
                        I: { cls: "received",  color: "#f5a623", icon: <IconHub /> },
                        P: { cls: "delivery",  color: "#EEF6FF", icon: <IconScooter /> },
                        U: { cls: "delivered", color: "#16a34a", icon: <IconDelivered /> },
                      }[t.refType] || { cls: "done", color: "#94a3b8", icon: <IconArrow /> };

                      return (
                        <div key={i} className="gs-tl-item done">
                          <div className="gs-tl-line-wrap">
                            <div
                              className={`gs-tl-dot ${stageMeta.cls}`}
                              style={{ background: stageMeta.color, color: "#fff" }}
                            >
                              {stageMeta.icon}
                            </div>
                          </div>
                          <div className="gs-tl-body">
                            <div className={`gs-tl-status ${t.refType === "U" ? "delivered" : ""}`}>{t.status}</div>
                            <div className="gs-tl-time">{t.date} &nbsp;{t.time}</div>
                            <div className="gs-tl-ref">{t.refNo}</div>
                            <div className="gs-tl-badges">
                              <span className="gs-tl-badge branch">{t.branch}</span>
                              {t.remark && (
                                <span
                                  className="gs-tl-badge remark"
                                  title={t.remark}
                                  style={{ maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block", verticalAlign: "bottom" }}
                                >
                                  {t.remark}
                                </span>
                              )}
                              {t.receivedBy && <span className="gs-tl-badge user">{t.receivedBy}</span>}
                              {t.signaturePath && (
                                <img
                                  src={imgUrl(t.signaturePath)}
                                  alt="Signature"
                                  title="Click to view signature"
                                  style={{ height: 22, cursor: "pointer", border: "1px solid var(--gs-border, #ddd)", borderRadius: 4, background: "#fff", verticalAlign: "middle" }}
                                  onClick={() => setLightboxItem({ name: `${t.receivedBy || "Receiver"}'s Signature`, type: "Signature", icon: "✍️", relativePath: t.signaturePath, fullUrl: t.signaturePath })}
                                />
                              )}
                              <span className="gs-tl-badge mode">{t.mode}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  </div>

                  {/* POD */}
                  {!!data.pods?.length && (
                    <div className="gs-pod-wrap">
                      {data.pods.map((p, i) => (
                        <button key={i} className="gs-pod-btn has-pod" onClick={() => setLightboxItem({ name: p, type: "POD", icon: "✍️" })}>
                          <IconFile /> {p}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Booking Location */}
                <div className="gs-card">
                  <div className="gs-band">
                    <div className="gs-band-icon"><IconPin /></div>
                    <div>
                      <div className="gs-band-title">Booking Location</div>
                      <div className="gs-band-sub">Captured via GPS at booking</div>
                    </div>
                  </div>
                  <div className="gs-card-body" style={{ padding: "12px 14px" }}>
                    <GeoMap
                      lat={data.bookingLat}
                      lng={data.bookingLng}
                      address={data.bookingLocation || data.bookPlace}
                      entryMode={data.modeOfEntry || "WEB"}
                      onToast={toast}
                    />
                    {data.deliveryLocation && (
                      <div className="gs-geo-card" style={{ marginTop: 10 }}>
                        <div className="gs-geo-detail">
                          <div className="gs-ic-lbl" style={{ marginBottom: 4 }}>📍 Delivery Location</div>
                          <div className="gs-geo-addr" style={{ color: "var(--gs-teal)" }}>{data.deliveryLocation}</div>
                          {data.deliveryLat && (
                            <div className="gs-geo-meta-row">
                              <span style={{ fontSize: "10.5px", color: "var(--gs-muted)", fontFamily: "monospace" }}>
                                {data.deliveryLat.toFixed(4)}, {data.deliveryLng.toFixed(4)}
                              </span>
                              <span className="gs-geo-link" onClick={() => toast(`Opening ${data.deliveryLat.toFixed(4)}, ${data.deliveryLng.toFixed(4)} in Maps…`, "info")}>
                                <IconExternalLink /> Maps
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {data.podLocation && (
                      <div className="gs-geo-card" style={{ marginTop: 10 }}>
                        <div className="gs-geo-detail">
                          <div className="gs-ic-lbl" style={{ marginBottom: 4 }}>🧾 POD Location</div>
                          <div className="gs-geo-addr" style={{ color: "var(--gs-green)" }}>{data.podLocation}</div>
                          {data.podLat && (
                            <div className="gs-geo-meta-row">
                              <span style={{ fontSize: "10.5px", color: "var(--gs-muted)", fontFamily: "monospace" }}>
                                {data.podLat.toFixed(4)}, {data.podLng.toFixed(4)}
                              </span>
                              <span className="gs-geo-link" onClick={() => toast(`Opening ${data.podLat.toFixed(4)}, ${data.podLng.toFixed(4)} in Maps…`, "info")}>
                                <IconExternalLink /> Maps
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

            </div>{/* /gs-main-layout */}
          </div>
        )}

      </div>{/* /gs-page */}

      {/* LIGHTBOX */}
      {lightboxItem && (
        <Lightbox item={lightboxItem} onClose={() => setLightboxItem(null)} onToast={toast} />
      )}

      {/* TOAST */}
      <ToastWrap toasts={toasts} />

    </div>
  );
}